
<template>
    <el-dialog :title="title" width="900px" :visible.sync="dialogFormVisible">
        <el-container>
            <el-aside width="200px" class="avatar">
                <img :src="info.avatar?info.avatar:info.headimgurl" />
                </el-aside>
            <el-main style="margin-top:0px;padding:0px;">
                <el-row>
                    <el-col :span="24">
                        <span class="value" style="font-size: 25px;padding-right: 10px;">{{info.userName}}</span>
                        <span class="value">{{info.phone}}</span>
                    </el-col>

                </el-row>
                <el-row style="margin-top: 15px;">
                    <el-col :span="24">
                        <span class="lable">移入原因：</span>
                        <span class="value">{{blackinfo.userTips}}</span>
                    </el-col>
                </el-row>
                <el-row style="margin-bottom: 15px;">
                    <el-col :span="24">
                        <span class="lable">操作人：</span>
                        <span class="value" style="padding-right: 20px;">{{blackinfo.createUserName}}</span>
                        <span class="value">{{blackinfo.inBlackTime}}</span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <span class="lable">技能：</span>
                        <span class="value">{{info.skillTips}}</span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <span class="lable">工种：</span>
                        <span class="value">{{info.workTypeIds}}</span>
                    </el-col>
                   <el-col :span="12">
                       <span class="lable">注册时间：</span>
                       <span class="value">{{info.createtime}}</span>
                   </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                      <span class="lable">服务城市：</span>
                      <span class="value">{{info.serviceRegion}}</span>
                  </el-col>
                    <el-col :span="12">
                        <span class="lable">真实姓名：</span>
                        <span class="value">{{info.cardName}}</span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <span class="lable">所属群组：</span>
                        <span class="value">{{info.groupNames}}</span>
                    </el-col>
                    <el-col :span="12">
                        <span class="lable">实名认证：</span>
                        <span class="value">{{info.workerState==2?'已实名':info.workerState==1?'待审核':'未实名'}}</span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <span class="lable">备用联系电话：</span>
                        <span class="value">{{info.backupPhone}}</span>
                    </el-col>
                    <el-col :span="12">
                        <span class="lable">身份证号码：</span>
                        <span class="value">{{info.cardNum}}</span>
                    </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                      <span class="lable">紧急联系人姓名：</span>
                      <span class="value">{{info.contactsName}}</span>
                  </el-col>
                  <el-col :span="12">
                      <span class="lable">团队认证：</span>
                      <span class="value">{{info.isForeman=='1'?'已认证':'未认证'}}</span>
                  </el-col>
                </el-row>
                <el-row>
                 <el-col :span="12">
                     <span class="lable">紧急联系人电话：</span>
                     <span class="value">{{info.contactsPhone}}</span>
                 </el-col>
                 <el-col :span="12">
                     <span class="lable">个人简介：</span>
                     <span class="value">{{info.introduce?info.introduce:''}}</span>
                 </el-col>
                </el-row>
            </el-main>
        </el-container>
         <div slot="footer" class="dialog-footer">
            <el-button class="filter-item" size="mini" @click="removeBlack" type="primary" icon="el-icon-delete-solid">移出黑名单</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {getCompanyWorkerInfo,removeBlack,blackWorkerList,getMyWorkerInfo} from '@/api/admin/workerUser'
import waves from '@/directive/waves/index.js' // 水波纹指令
import { objKeySort } from '@/util/ajaxsign'
import { dateOnce } from '@/util/dateT'
import {
    getImgLink
  } from '@/config/env'
export default {
    name: 'worker_info',
    directives: {
        waves
    },
    data() {
        return {
            title : '师傅详情',
            dialogFormVisible:false,
            queryList:{
                userId:''
            },
            dic:{
                  workTypes:[],
                  skillTips:[],
                  groups:[]
                },
            info : {
                userName :''
            },
            blackinfo:{},
            coldderail : true,
        }
    },
    created() {},
    methods: {
        refresh(){
            this.$emit('refresh');
        },
        //查看数据展示
        setUserId(user,dic){
          let that=this
          that.dic=dic
          that.queryList.userId = user.userId;
          // that.queryList.type=1;
          getMyWorkerInfo(objKeySort({userId:user.userId})).then(response => {
              if(response&&response.data){
                blackWorkerList(objKeySort({condition:user.phone})).then(response => {
                    if(response&&response.data){
                      that.blackinfo = response.data.data[0];
                      if(that.blackinfo.createTime){
                        that.blackinfo.inBlackTime=dateOnce(that.blackinfo.createTime)
                      }
                    }
                });
                that.info = response.data.data;
                if(that.info.cardNum){
                    that.info.cardNum = that.formatterCarNum(that.info.cardNum);
                }
                if(that.info.avatar){
                  that.info.avatar= getImgLink(that.info.avatar);
                }
                if(that.info.workTypeIds){
                    that.info.workTypeIds = that.formatterWorkType(that.info.workTypeIds);
                }
                if(that.info.skillTips){
                    that.info.skillTips = that.formatterSkillTips(that.info.skillTips);
                }
                if(that.info.mySkillTips){
                  that.info.skillTips=that.info.skillTips?(that.info.skillTips+','):''+that.info.mySkillTips
                }
                if(that.info.userGroups){
                  that.info.groupNames=that.formatteruserGroups(that.info.userGroups);
                }

                that.info.createtime = dateOnce(response.data.data.createtime)
              }
          });
          that.dialogFormVisible = true;
        },
        formatteruserGroups(groups){
          let _groupNames=''
          groups.forEach(item=>{
            _groupNames+=item.groupName+','
          })
          return _groupNames=_groupNames.substring(0,_groupNames.length-1)
        },
        formatterCarNum(cardNum){
            var newCarNum = '';
            if(cardNum&&cardNum.length>0){
            let str = cardNum.split("");
            for(var i = 0;i<str.length;i++){
               if(i<6||i>=str.length-4){
                newCarNum = newCarNum+str[i];
                }else{
                newCarNum = newCarNum+"*";
                }
            }
            }
            return  newCarNum;
        },
        formatterWorkType(workTypeIds){
            switch (workTypeIds) {
                case '1':
                    return "搬运工"
                    break;
                    case '2':
                    return "安装工"
                    break;
                    case '3':
                    return "补漆工"
                    break;
                    case '4':
                    return "维修工"
                    break;
                default:
                    return ''
                    break;
            }
            // var  workTypeNames = '';
            // if(workTypeIds&&workTypeIds.length>0){
            //     workTypeIds.split(",").forEach(workerTypeId =>{
            //         if(this.dic.workTypes){
            //             this.dic.workTypes.forEach(workerType => {
            //                 if(workerType.id==workerTypeId){
            //                     workTypeNames = workTypeNames + workerType.name +',';
            //                 }
            //             })
            //         }else{
            //             return workTypeIds;
            //         }

            //     })
            // }
            // if(workTypeNames.length>0){
            //     workTypeNames = workTypeNames.substring(0,workTypeNames.length-1);
            // }
            // return  workTypeNames;
        },
        removeBlack(){
                let that=this
                that.$confirm(
                '您确定要将用户“' + that.info.userName + '”移出到黑名单吗,移出后该用户可以继续接您企业的项目，是否继续?',
                '提示',
                {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }
              ).then(() => {
              removeBlack(objKeySort({bwId:that.blackinfo.bwId})).then(response => {
                  if(response&&response.data&&response.data.code===200){
                      that.$message({
                          title: '成功',
                          message: '移出黑名单成功',
                          type: 'success',
                          duration: 2000
                      })
                     that.dialogFormVisible = false;
                     that.$emit('refresh');
                  }else{
                          that.$message({
                          title: '失败',
                          message: '移出黑名单失败',
                          type: 'error',
                          duration: 2000
                      })
                  }
              });
            })
        },
        formatterSkillTips(skillTips){
            var  skillTipNames = '';
            if(skillTips&&skillTips.length>0){
                skillTips.split(",").forEach(skillTipId =>{
                    if(this.dic.skillTips){
                        this.dic.skillTips.forEach(skillTip => {
                            if(skillTip.id==skillTipId){
                                skillTipNames = skillTipNames + skillTip.name +',';
                            }
                        })
                    }else{
                        return skillTipNames;
                    }

                })
            }
            if(skillTipNames.length>0){
                skillTipNames = skillTipNames.substring(0,skillTipNames.length-1);
            }
            return  skillTipNames;
        }
    }
}
</script>
<style scoped="scoped">
  .avatar img{
    width: 150px;
    height: 150px;
    border-radius: 50%;
  }
</style>
